module.exports = __webpack_public_path__ + "img/menu-close.62cb5733.svg";